module.exports = __webpack_public_path__ + "static/media/pridefit_03.003b0445.jpg";